import { render, staticRenderFns } from "./poa.vue?vue&type=template&id=4f31fc25"
import script from "./poa.vue?vue&type=script&lang=js"
export * from "./poa.vue?vue&type=script&lang=js"
import style0 from "./poa.vue?vue&type=style&index=0&id=4f31fc25&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f31fc25')) {
      api.createRecord('4f31fc25', component.options)
    } else {
      api.reload('4f31fc25', component.options)
    }
    module.hot.accept("./poa.vue?vue&type=template&id=4f31fc25", function () {
      api.rerender('4f31fc25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents/poa.vue"
export default component.exports